import React from 'react';
import { TabContent, TopicsTabContent } from './TabContentComponent';

// 사용 예시
const TabsSection = ({
    activeTab,
    selectedTest,
    engtag,
    mathtag,
    readingtag,
    sciencetag,
    missing_topics,
    handleButtonClick
}) => {
    const getTabContent = () => {
        switch (activeTab) {
            case "all":
                return (
                    <div>
                        {/* Stats */}
                        {(() => {
                            const total = JSON.parse(selectedTest.section_data).length;
                            const correct = engtag.filter(e => e.correct).length + mathtag.filter(e => e.correct).length;
                            const incorrect = engtag.filter(e => !e.correct).length + mathtag.filter(e => !e.correct).length;
                            const pct = total > 0 ? Math.round((correct / total) * 100) : 0;
                            const barColor = pct >= 75 ? 'bg-emerald-400/80' : pct >= 50 ? 'bg-blue-400/80' : 'bg-rose-400/80';
                            return (
                                <>
                                    <div className="grid grid-cols-3 gap-2 mt-3 mb-1">
                                        <div className="bg-slate-50 border border-slate-200 p-3.5 flex flex-col items-center">
                                            <p className="text-2xl font-bold tabular-nums text-slate-800">{total}</p>
                                            <p className="text-[10px] font-medium text-slate-400 mt-1 uppercase tracking-wider">Total</p>
                                        </div>
                                        <div className="bg-emerald-50 border border-emerald-100 p-3.5 flex flex-col items-center">
                                            <p className="text-2xl font-bold tabular-nums text-emerald-700">{correct}</p>
                                            <p className="text-[10px] font-medium text-emerald-500/70 mt-1 uppercase tracking-wider">Correct</p>
                                        </div>
                                        <div className="bg-rose-50 border border-rose-100 p-3.5 flex flex-col items-center">
                                            <p className="text-2xl font-bold tabular-nums text-rose-600">{incorrect}</p>
                                            <p className="text-[10px] font-medium text-rose-400/70 mt-1 uppercase tracking-wider">Incorrect</p>
                                        </div>
                                    </div>
                                    <div className="mb-3 px-0.5">
                                        <div className="flex justify-between text-xs text-slate-400 mb-1.5">
                                            <span>Accuracy</span>
                                            <span className="font-semibold tabular-nums text-slate-600">{pct}%</span>
                                        </div>
                                        <div className="h-1.5 bg-slate-100 overflow-hidden">
                                            <div className={`h-full ${barColor} transition-all duration-700`} style={{ width: `${pct}%` }} />
                                        </div>
                                    </div>
                                </>
                            );
                        })()}

                        {/* 여러 테이블 섹션 */}
                        {engtag.length > 0 && (
                            <div className="mt-4 overflow-y-auto">
                                <QuestionTable
                                    items={engtag}
                                    selectedTest={selectedTest}
                                    sectionName={selectedTest?.type === "ACT" ? "English" : "Reading and Writing"}
                                    handleButtonClick={handleButtonClick}
                                    questionIdField={selectedTest?.type === "ACT" ? "qid" : "questionIds"}
                                />
                            </div>
                        )}

                        {mathtag.length > 0 && (
                            <div className="mt-4 overflow-y-auto">
                                <QuestionTable
                                    items={mathtag}
                                    selectedTest={selectedTest}
                                    sectionName="Math"
                                    handleButtonClick={handleButtonClick}
                                    questionIdField={
                                        (selectedTest?.type === "AP_Calc_AB" || selectedTest?.type === "AP_Calc_BC")
                                            ? "question_id"
                                            : (selectedTest?.type === "ACT" ? "qid" : "questionIds")
                                    }
                                />
                            </div>
                        )}

                        {/* ACT에서만 사용되는 추가 섹션들 */}
                        {selectedTest?.type === "ACT" && readingtag.length > 0 && (
                            <div className="mt-4 overflow-y-auto">
                                <QuestionTable
                                    items={readingtag}
                                    selectedTest={selectedTest}
                                    sectionName="Reading"
                                    handleButtonClick={handleButtonClick}
                                    questionIdField="qid"
                                />
                            </div>
                        )}

                        {selectedTest?.type === "ACT" && sciencetag.length > 0 && (
                            <div className="mt-4 overflow-y-auto">
                                <QuestionTable
                                    items={sciencetag}
                                    selectedTest={selectedTest}
                                    sectionName="Science"
                                    handleButtonClick={handleButtonClick}
                                    questionIdField="qid"
                                />
                            </div>
                        )}
                    </div>
                );

            case "readingWriting":
                return (
                    <TabContent
                        items={engtag}
                        correctItems={engtag.filter(e => e.correct).length}
                        incorrectItems={engtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Reading and Writing"
                        handleButtonClick={handleButtonClick}
                        questionIdField="questionIds"
                        tagField="tag"
                    />
                );

            case "math":
                return (
                    <TabContent
                        items={mathtag}
                        correctItems={mathtag.filter(e => e.correct).length}
                        incorrectItems={mathtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Math"
                        handleButtonClick={handleButtonClick}
                        questionIdField={
                            (selectedTest?.type === "AP_Calc_AB" || selectedTest?.type === "AP_Calc_BC")
                                ? "question_id"
                                : (selectedTest?.type === "ACT" ? "qid" : "questionIds")
                        }
                        tagField="tag"
                    />
                );

            case "english":
                return (
                    <TabContent
                        items={engtag}
                        correctItems={engtag.filter(e => e.correct).length}
                        incorrectItems={engtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="English"
                        handleButtonClick={handleButtonClick}
                        questionIdField="qid"
                        tagField="tag"
                    />
                );

            case "reading":
                return (
                    <TabContent
                        items={readingtag}
                        correctItems={readingtag.filter(e => e.correct).length}
                        incorrectItems={readingtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Reading"
                        handleButtonClick={handleButtonClick}
                        questionIdField="qid"
                        tagField="tag"
                    />
                );

            case "science":
                return (
                    <TabContent
                        items={sciencetag}
                        correctItems={sciencetag.filter(e => e.correct).length}
                        incorrectItems={sciencetag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Science"
                        handleButtonClick={handleButtonClick}
                        questionIdField="qid"
                        tagField="tag"
                    />
                );

            case "topics":
                return (
                    <TopicsTabContent
                        missingTopics={missing_topics}
                        selectedTest={selectedTest}
                        handleButtonClick={handleButtonClick}
                    />
                );

            case "mcq":
                return (
                    <TabContent
                        items={engtag}
                        correctItems={engtag.filter(e => e.correct).length}
                        incorrectItems={engtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Multiple Choice"
                        handleButtonClick={handleButtonClick}
                        questionIdField="question_id"
                        tagField="tag"
                    />
                );

            case "frq":
                return (
                    <TabContent
                        items={mathtag}
                        correctItems={mathtag.filter(e => e.correct).length}
                        incorrectItems={mathtag.filter(e => !e.correct).length}
                        selectedTest={selectedTest}
                        sectionName="Free Response"
                        handleButtonClick={handleButtonClick}
                        questionIdField="question_id"
                        tagField="tag"
                    />
                );

            default:
                return null;
        }
    };

    return getTabContent();
};

const QuestionTable = ({
    items,
    selectedTest,
    sectionName,
    handleButtonClick,
    questionIdField = 'questionIds',
    tagField = 'tag'
}) => {
    const formatAnswer = (questionObj) => {
        try {
            const parsed = JSON.parse(questionObj.correct_answer);
            const val = Array.isArray(parsed) ? parsed.join(", ") : questionObj.correct_answer;
            return val.length > 10 ? "—" : val;
        } catch {
            return questionObj.correct_answer?.length > 10 ? "—" : questionObj.correct_answer;
        }
    };

    return (
        <div className="mt-3 border border-slate-200 overflow-hidden">
            <div
                className="max-h-[480px] overflow-y-auto"
                style={{ scrollbarWidth: 'thin', scrollbarColor: '#cbd5e1 transparent' }}
            >
                <table className="min-w-full">
                    <thead className="sticky top-0 z-10">
                        <tr className="bg-slate-50 border-b border-slate-200">
                            <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest">#</th>
                            <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest">Section</th>
                            <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest">Answer</th>
                            <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest">Yours</th>
                            <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest">View</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {items.map((questionObj, index) => (
                            <tr
                                key={index}
                                className={`transition-colors duration-100 ${
                                    questionObj.correct
                                        ? 'bg-white hover:bg-slate-50'
                                        : 'bg-rose-50/60 hover:bg-rose-50'
                                }`}
                            >
                                <td className="px-3 py-2.5">
                                    <span className={`inline-flex w-6 h-6 items-center justify-center text-[11px] font-bold ${
                                        questionObj.correct
                                            ? 'text-emerald-600'
                                            : 'text-rose-500'
                                    }`}>
                                        {index + 1}
                                    </span>
                                </td>
                                <td className="px-3 py-2.5 text-xs text-slate-400 max-w-[80px] truncate">{sectionName}</td>
                                <td className="px-3 py-2.5 text-xs font-medium text-slate-700 capitalize">
                                    {formatAnswer(questionObj)}
                                </td>
                                <td className="px-3 py-2.5 text-xs font-medium">
                                    {questionObj.selectedOption
                                        ? <span className="text-slate-700">{questionObj.selectedOption}</span>
                                        : <span className="text-slate-400 italic text-[11px]">Omitted</span>
                                    }
                                </td>
                                <td className="px-3 py-2.5">
                                    <button
                                        className="text-[11px] font-medium px-2.5 py-1 bg-slate-100 text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-all duration-100"
                                        onClick={() =>
                                            handleButtonClick(
                                                questionObj.selectedOption,
                                                questionObj[questionIdField],
                                                questionObj[tagField],
                                                selectedTest?.type,
                                                items,
                                                index
                                            )
                                        }
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TabsSection;